import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NzCardModule } from 'ng-zorro-antd/card';

/**
 * Tarjeta contenedora.
 *
 * Envuelve `nz-card` para sacar el marcado de ng-zorro de las plantillas de feature.
 *
 * Ojo con los estilos: varias hojas apuntaban a `nz-card ::ng-deep .ant-card-body`. Angular
 * escopa la parte anterior a `::ng-deep`, y `nz-card` pasó a declararse aquí dentro, así que
 * esos selectores debieron reescribirse a `app-card ::ng-deep .ant-card-body`.
 *
 * `styleClass` existe porque una clase puesta en `<app-card class="...">` caería en el host
 * y no sobre el elemento de ng-zorro, que es lo que las hojas actuales esperan estilar.
 */
@Component({
  standalone: true,
  selector: 'app-card',
  imports: [NzCardModule],
  template: `
    <nz-card [nzBordered]="bordered()" [class]="styleClass()">
      <ng-content></ng-content>
    </nz-card>
  `,
  styles: [':host { display: block; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppCardComponent {
  /** Igual que `nzBordered`: por defecto la tarjeta lleva borde. */
  bordered = input<boolean>(true);
  /** Clases que deben aplicarse al elemento `nz-card`, no al host. */
  styleClass = input<string>('');
}
